import { callWithRetry } from "../../services/callWithRetry";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";
import { API_PDC_URL_V1 } from "../../../config";

export const movementsConstants = {
  GET_RECONCILIATION_MOVEMENTS_START: "GET_RECONCILIATION_MOVEMENTS_START",
  GET_RECONCILIATION_MOVEMENTS_SUCCESS: "GET_RECONCILIATION_MOVEMENTS_SUCCESS",
  GET_RECONCILIATION_MOVEMENTS_ERROR: "GET_RECONCILIATION_MOVEMENTS_ERROR",
  SET_MOVEMENT_LINKED: "SET_MOVEMENT_LINKED",

  GET_RECONCILIATION_DATA_START: "GET_RECONCILIATION_DATA_START",
  GET_RECONCILIATION_DATA_SUCCESS: "GET_RECONCILIATION_DATA_SUCCESS",
  GET_RECONCILIATION_DATA_ERROR: "GET_RECONCILIATION_DATA_ERROR"
};

export function loadReconciliationMovements(
  auth, accountantUuid, companyUuid, account, fromDate, toDate, type
) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: movementsConstants.GET_RECONCILIATION_MOVEMENTS_START
      });

      let request = {
        method: "get",
        url: API_PDC_URL_V1 + `/banks/transactions?itemId=${companyUuid}&managerId=${accountantUuid}&from=${fromDate}&to=${toDate}&type=${type}`,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      };

      callWithRetry(
        auth, request, dispatch, null, false, false, ["401"]
      )
        .then((result) => {
          if (result.status === 200) {
            dispatch({
              type: movementsConstants.GET_RECONCILIATION_MOVEMENTS_SUCCESS,
              payload: result.data
            });
          } else {
            dispatch({
              type: movementsConstants.GET_RECONCILIATION_MOVEMENTS_ERROR,
              error: result
            });
          }
          resolve(result.data);
        })
        .catch((response) => {
          dispatch({
            type: movementsConstants.GET_RECONCILIATION_MOVEMENTS_ERROR,
            payload: response.toString()
          });
          reject(response);
        });
    });
  };
}

export function setMovementLinked(movementId) {
  return (dispatch) => {
    dispatch({
      type: movementsConstants.SET_MOVEMENT_LINKED,
      payload: movementId
    });
  };
}

export function getReconciliationData(movementId, deadlineId) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;

    let urlRec = `${API_PDC_URL_V1}/reconciliation/conciliated?deadlineId=${deadlineId}&managerId=${managerId}&itemId=${itemId}`;
    if (movementId) {
      urlRec = `${API_PDC_URL_V1}/reconciliation/conciliated?bankTransactionId=${movementId}&managerId=${managerId}&itemId=${itemId}`;
    }
    return new Promise((resolve, reject) => {
      dispatch({
        type: movementsConstants.GET_RECONCILIATION_DATA_START
      });

      let request = {
        method: "get",
        url: urlRec,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      };

      callWithRetry(
        auth, request, dispatch, null, false, false, ["401"]
      )
        .then((result) => {
          if (result.status === 200) {
            dispatch({
              type: movementsConstants.GET_RECONCILIATION_DATA_SUCCESS,
              payload: result.data.reconciliations
            });
          } else {
            dispatch({
              type: movementsConstants.GET_RECONCILIATION_DATA_ERROR,
              error: result
            });
          }
          resolve(result);
        })
        .catch((response) => {
          dispatch({
            type: movementsConstants.GET_RECONCILIATION_MOVEMENTS_ERROR,
            payload: response.toString()
          });
          reject(response);
        });
    });
  };
}
